module.exports = __webpack_public_path__ + "img/beaches_near_paris_fb_1_700x367.0cf196f8.jpeg";